import { ForHireFetchers } from "./forHire.ts"

import type { ForHireSummaryConfig } from "../types/forHireSummaryTypes.ts"

const forHireConfig: Map<number, ForHireSummaryConfig> = new Map()
forHireConfig.set(1, ForHireFetchers)

export default forHireConfig
